import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TaListReportPage from './components/TaListReportPage';
import { useAttendanceCardReport, ATTENDANCE_CARD_EXPORT_URL } from './config/attendanceCard';

const FORMATS = ['pdf', 'zip', 'xlsx'];

// AKM POC §7.2 — Personel Devam Kartı: kişi listesi + kart dosyaları (grup için tek PDF, kişi başı ZIP ya da kişi başı
// sayfalı Excel; satırda tek kişinin kartı).
export default function AttendanceCardPage() {
  const { t } = useTranslation();
  const report = useAttendanceCardReport();
  const formatLabels = useMemo(() => ({
    pdf: t('reportExport.pdfAll'),
    zip: t('reportExport.zipPerPerson'),
  }), [t]);
  return (
    <TaListReportPage
      title={t('taReports.attendanceCard.title')}
      report={report}
      exportUrl={ATTENDANCE_CARD_EXPORT_URL}
      formats={FORMATS}
      formatLabels={formatLabels}
    />
  );
}
